import { render, staticRenderFns } from "./TableTraceability.vue?vue&type=template&id=0311b6dd&"
import script from "./TableTraceability.vue?vue&type=script&lang=js&"
export * from "./TableTraceability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports